import React from 'react';
import { string, shape, number, arrayOf, func } from 'prop-types';

import sortSegments from 'helpers/sortSegments';

import List from '../../Overview/List';
import ListItem from '../../Overview/ListItem';
import SegmentsListItem from '../../Overview/SegmentsListItem';

import styles from './RouteSegments.scss';

export default function RouteSegments({ title, segments, selectEntity, enterEntity, leaveEntity }) {
  return (
    <section className={styles.segments}>
      <h2 className={styles.listHeading}>
        {title}
      </h2>
      <List>
        {sortSegments(segments, 'tti', 'asc').map(segment => {
          const { id, status } = segment;

          return (
            <ListItem
              id={id}
              key={id}
              status={status}
              contentType="segment"
              onClick={() => selectEntity({ id, type: 'segment' })}
              onMouseOver={() => enterEntity({ id, type: 'segment' })}
              onMouseOut={() => leaveEntity({ id, type: 'segment' })}
            >
              <SegmentsListItem segment={segment} sortValue="tti" />
            </ListItem>
          );
        })}
      </List>
    </section>
  );
}

RouteSegments.propTypes = {
  title: string.isRequired,
  segments: arrayOf(
    shape({
      id: string,
      status: string,
      expectedTravelTime: number,
      travelTimeIndex: number,
      numberOfTripsToday: number,
      numberOfTripsSinceLastUpdate: number,
      from: shape({
        name: string,
      }),
      to: shape({
        name: string,
      }),
    })
  ).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/RouteSegments/index.js